import api from "../api";

export const useSellPropertyToken = (data) => {
  const { id, ...data2 } = data;
  return api
    .post(`/property/${id}/create-order`, data2)
    .then((res) => res.data);
};
